<template>
  <div class="mt-4 ml-3 d-flex justify-content-between">
    <span class="pagination-info" :class="{ hidden: !showText }">
      Mostrando {{ startIndex }} al {{ endIndex }} de {{ total }} resultados
    </span>
    <ul class="pagination mr-3 d-flex flex-wrap">
      <li
        v-if="currentPage > pageButtonCount - pageButtonOffset"
        class="mr-2 bg-light-gray"
      >
        <a @click="goToPage(1)">
          <i class="fa fa-chevron-double-left" />
        </a>
      </li>

      <li v-if="currentPage > 1" class="mr-2  bg-light-gray">
        <a @click="goToPage(currentPage - 1)">
          <i class="fa fa-chevron-left" />
        </a>
      </li>

      <li
        v-for="(page, index) in pages"
        :key="page"
        class="custom-border border-top border-bottom p-page"
        :class="{
          first: index === 0,
          last: index === pages.length - 1,
          active: page === currentPage,
        }"
      >
        <a @click="goToPage(page)">{{ page }}</a>
      </li>

      <li v-if="currentPage < data.pageCount" class="ml-2">
        <a class="bg-light-gray" @click="goToPage(currentPage + 1)">
          <i class="fa fa-chevron-right" />
        </a>
      </li>

      <li v-if="currentPage < data.pageCount - pageButtonOffset" class="ml-2">
        <a class="bg-light-gray" @click="goToLastPage()">
          <i class="fa fa-chevron-double-right" />
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.pagination-info {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.pagination {
  cursor: pointer;
  font: Bold 14px/17px Lato;

  li {
    background: #f2f2f2 0% 0% no-repeat padding-box;
    border-radius: 0;
    border: 0;

    &.p-page {
      background: #ffff;
    }

    &:not(.p-page) {
      border-radius: 4px;
      border: 1px solid #dee2e6;
    }

    &.active {
      border-color: #2b9d71;
      background: #2b9d71;
      color: #fff;
      overflow: hidden;

      a {
        color: #fff;
      }
    }

    &.first {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-left: 1px solid #dee2e6;
      overflow: hidden;
    }

    &.last {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-right: 1px solid #dee2e6;
      overflow: hidden;
    }

    &:last-child:empty {
      border-radius: 0;
      border: 0;
      background: none;
    }

    a {
      min-width: 33px;
      height: 34px;
      position: relative;
      float: left;
      text-align: center;
      line-height: 34px;
      letter-spacing: 0;
      color: #11291b;
      text-decoration: none;
    }
  }
}
</style>

<script>
export default {
  name: 'Pagination',
  meta: {
    description: 'Indica contenido relacionado en varias páginas.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    showText: {
      type: Boolean,
      required: false,
      default: true,
    },
    data: {
      type: Object,
      default() {
        return {
          currentPage: 0,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
        };
      },
      meta: {
        description: 'Establece la data relacionada al componente',
        example: '',
      },
    },
  },
  data() {
    return {
      pageButtonCount: 5,
      pageButtonOffset: 2,
    };
  },
  computed: {
    pages() {
      const pages = [];
      const offset = this.pageButtonOffset;
      let endAt = this.pageButtonCount;
      let startAt = 1;

      if (
        this.currentPage > 3 &&
        this.data.pageCount > this.currentPage + offset
      ) {
        endAt = this.currentPage + offset;
        startAt = this.currentPage - offset;
      } else if (
        this.currentPage > 3 &&
        this.currentPage <= this.data.pageCount
      ) {
        endAt = this.data.pageCount;
        startAt = this.data.pageCount - 4;
      }

      if (startAt <= 0) startAt = 1;

      let qtyButtons = 0;

      if (this.data.pageCount <= endAt) {
        qtyButtons = this.data.pageCount;
      } else {
        qtyButtons = endAt;
      }

      for (let i = startAt; i <= qtyButtons; i++) {
        pages.push(i);
      }

      return pages;
    },
    total() {
      return this.data.totalItemCount;
    },
    startIndex() {
      let pageSize = this.data.pageSize || this.data.count;

      let startIndex = pageSize * this.currentPage - pageSize;

      if (startIndex === 0) {
        startIndex = 1;
      }

      if (
        (this.data.totalItemCount > 0) & (this.currentPage > 1) &&
        this.data.count < 5
      ) {
        startIndex = this.data.totalItemCount - this.data.count;
      }
      if (this.currentPage > 1) {
        startIndex = startIndex + 1;
      }
      return startIndex;
    },
    endIndex() {
      let pageSize = this.data.count;

      let endIndex = this.startIndex;

      if (this.currentPage === this.data.pageCount)
        endIndex = this.data.totalItemCount;
      else endIndex += pageSize - 1;
      return endIndex;
    },
    currentPage() {
      return this.data.currentPage;
    },
  },
  methods: {
    goToPage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.data.pageCount) return;
      if (pageNumber !== this.currentPage) {
        this.$emit('pagination-go-page', pageNumber);
      }
    },
    goToLastPage() {
      if (this.currentPage == this.data.pageCount) return;

      this.$emit('pagination-go-page', this.data.pageCount);
    },
  },
};
</script>
